var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"thumbs-video"},[_c('div',{staticClass:"thumbs-video__black",class:{
            'thumbs-video__black_active': _vm.isActive
        }}),_vm._v(" "),_c('div',{staticClass:"thumbs-video__icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }